export class Login {    
    userName!: string;    
    fullName!: string;    
    isLoggedIn!: boolean;    
    role!: string;
  lastLogin!: string;
}    
